
$(document).ready(function (){

    // MENU

    $(document).on('click', '.js-hamburger', function(e) {
        $(this).toggleClass('c-header__hamburger--active');
        $('body').toggleClass('u-no-scroll');
        $('.js-menu').toggleClass('c-header__menu--active');
        $('.js-header').toggleClass('c-header--active');
        $('.js-lang-switcher').removeClass('c-header__language-container--active');

        if($(this).hasClass('c-header__hamburger--active')) {
            $('.js-menu-contact').appendTo('.js-menu-inner');
        }
        else {
            $('.js-menu-contact').insertAfter('.js-menu');
        }
    });

    var mq = window.matchMedia("(max-width: 1030px)");

    $(document).on('click', '.menu-item-has-children > a', function (e){
        if (mq.matches) {
            e.preventDefault();
            $(this).next('.sub-menu').toggleClass('active');
        }
    });

    (function () {
        document.addEventListener('scroll', function(e) {
            (function () {
                if (window.scrollY < 1500 && window.scrollY > 100) {
                    document.getElementById("header").classList.add('c-header--hidden');
                } else {
                    document.getElementById("header").classList.remove( 'c-header--hidden');
                }
            })();
        });
    })();

    // LANGUAGES

    $(document).on('click', '.js-lang-switcher', function (){
        if (mq.matches) {
            $(this).addClass('c-header__language-container--active');
        }
    });

    $(document).on('click', '.js-lang-switcher a', function (e){
        if(mq.matches) {
            if (!$('.js-lang-switcher').hasClass('c-header__language-container--active')) {
                e.preventDefault();
            }
        }
    });

    // DODO PARTNER SPECIAL CASE CONTACT MENU

    if(window.location.href.indexOf('dodo-partner') > -1) {
        $(document).on('click', '.js-menu-contact a', function(e){
            e.preventDefault();
            $('body').removeClass('u-no-scroll');
            $('.js-menu').removeClass('c-header__menu--active');
            $('.js-hamburger').removeClass('c-header__hamburger--active');
            $('html, body').animate({
                scrollTop: $('.js-contact').offset().top - 80
            }, 500);
        });
    }

    // HP CAROUSEL

    if($('.js-carousel-content').length) {
        $('.js-carousel-content').slick({
            speed: 200,
            autoplay: true,
            autoplaySpeed: 8000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            asNavFor: '.js-carousel-nav',
            swipe: true,
            pauseOnHover: false
        });
        $('.js-carousel-nav').slick({
            speed: 200,
            slidesToShow: 4,
            asNavFor: '.js-carousel-content',
            dots: false,
            adaptiveHeight: true,
            centerMode: false,
            focusOnSelect: true,
            infinite: true,
            variableWidth: true,
            swipe: true,
            arrows: false,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
        setTimeout(function(){
            $('.js-carousel').addClass('c-carousel--active');
        },100);

    }

    // VIDEO HANDLERS

    $(document).on('click', '.js-gaia-video-play', function(e) {
        $('.js-gaia-video-container').addClass('c-gaia__video-src--visible');
        $('.js-gaia-video').trigger('play').prop('controls', 'true');
        $(this).fadeOut();
    });

    $(document).on('click', '.js-service-detail-play', function(e) {
        $('.js-service-detail-video').addClass('c-service-detail-intro__video--visible');
        $('.js-service-detail-video').trigger('play').prop('controls', 'true');
        $(this).fadeOut();
    });

    $(document).on('click', '.js-about-us-play', function(e) {
        $('.js-about-us-video').trigger('play').prop('controls', 'true');
        $(this).fadeOut();
    });

    // CASE STUDIES SLICK

    if($('.js-case-studies-slick').length) {
        $('.js-case-studies-slick').slick({
            speed: 200,
            autoplay: true,
            autoplaySpeed: 7000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            adaptiveHeight: true,
            swipe: true,
            pauseOnHover: false
        });
    }

    // WIDGET SLICK

    if($('.js-carousel-widget').length) {
        $('.js-carousel-widget').slick({
            speed: 200,
            autoplay: true,
            autoplaySpeed: 7000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            adaptiveHeight: true,
            swipe: true,
            pauseOnHover: false,
            dots: true
        });
    }

    // FAQ

    $(document).on('click', '.js-faq-title', function (){
        $('.js-faq-title').removeClass('c-faq__item-title--active');
        $(this).addClass('c-faq__item-title--active');
        $('.js-faq-content').removeClass('c-faq__item-text--active');
        $(this).next('.js-faq-content').addClass('c-faq__item-text--active');
    });

    // CLIENTS SLICK

    if($('.js-clients-slick').length) {
        $('.js-clients-slick').slick({
            speed: 200,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 4,
            slidesToScroll: 2,
            arrows: true,
            infinite: true,
            adaptiveHeight: true,
            swipe: true,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrow: false
                }
            }]
        });
    }

    // HISTORY SLICK

    if($('.js-history-slick').length) {
        $('.js-history-slick').slick({
            speed: 200,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            adaptiveHeight: true,
            swipe: true,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrow: false
                }
            }]
        });
    }

    // FRANCHISE STORIES SLICK

    if($('.js-franchise-stories-slick').length) {
        $('.js-franchise-stories-slick').slick({
            speed: 500,
            variableWidth:  true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            adaptiveHeight: true,
            swipe: true,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    // WORK AT DODO SLICK
    if($('.js-colleagues-slick').length) {
        $('.js-colleagues-slick').slick({
            speed: 500,
            variableWidth:  true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            // adaptiveHeight: true,
            swipe: true,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    // FORM
    /*
    (function () {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const formSent = urlParams.get('formSent');
        if(formSent == 'OK') {
            const form = document.getElementById("form");
            setTimeout(function(){
                form.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                $('.js-alert-message-success').addClass('wpcf7-alert-message--visible');
            },500);

            setTimeout(function(){
                $('.js-alert-message-success').removeClass('wpcf7-alert-message--visible');
            },5000);
        }
    })();

    */


    $('.js-form-industry-option').each(function(){
        $(this).appendTo('.js-form-industry-select').replaceWith('<option class="js-form-industry-option-replaced" value="' + $(this).data('value') + '">' + $(this).html() + '</option>');
    });
    /*
    if($('.js-form-return-URL').length) {
        $('.js-form-return-URL').val(window.location.href + '?formSent=OK')
    }
    */

    $(document).on('input', '.js-deliveries-count-src', function (){
        $('.js-deliveries-count-target').val($(this).val());
    });

    $(document).on('input', '.js-deliveries-count-target', function (){
        $('.js-deliveries-count-src').val($(this).val());
    });

    $(document).on('input', '.js-deliveries-count-src', function () {
        if ($(this).val() < 500) {
            $('.js-contact').removeClass('wpcf7-outer-container--bg-medium wpcf7-outer-container--bg-large');
        } else if($(this).val() > 500 && $(this).val() < 1200) {
            $('.js-contact').addClass('wpcf7-outer-container--bg-medium').removeClass('wpcf7-outer-container--bg-large');
        } else {
            $('.js-contact').addClass('wpcf7-outer-container--bg-large').removeClass('wpcf7-outer-container--bg-medium');
        }
    });

    $(document).on('submit', '.js-contact-form', function (e){
        $('.js-alert-message').removeClass('wpcf7-alert-message--visible');
        if ($('.js-deliveries-count-src').val() < 10) {
            e.preventDefault();
            $('.js-alert-message-count').addClass('wpcf7-alert-message--visible');
        } else if ($('.js-contact-delivery-checkbox-container input:checked').length == 0) {
            e.preventDefault();
            $('.js-alert-message-service').addClass('wpcf7-alert-message--visible');
        } else {
            return true;
        }
    });

    document.addEventListener( 'wpcf7mailsent', function(e) {
        e.preventDefault();

        if ($('#download-report').length > 0) {
            const reportUrl = $('#download-report').val();
            window.location.replace(reportUrl);
        } else {
            if ( $('#thank-you-url').length > 0 ) {
                const newUrl = $('#thank-you-url').val();
                window.location.replace(newUrl);
            } else if ( $('#thank-you-url-blank').length > 0) {
                const newUrl = $('#thank-you-url-blank').val();
                window.open(newUrl,'_blank').focus();
            } else if ( $('#thank-you-url-none').length > 0) {
                return;
            } else {
                window.location.replace(window.location.href + '/thank-you');
            }
        }

    });


    $('body').on('change', ".wpcf7-file__input", function() {
        if ($('.wpcf7-file__input input')[0].files[0]) {
            $(".wpcf7-file__label").addClass("inserted").text("Životopis vložen");
            $('.wpcf7-file__name').text($('.wpcf7-file__input input')[0].files[0].name).fadeIn();
        } else {
            $(".wpcf7-file__label").addClass("uninserted").text("Vložte životopis");
            $('.wpcf7-file__name').text('').fadeOut();
        }
    });

    // FOOTER LINKS

    $(document).on('click', '.js-footer-menu > li > a', function (e){
        e.preventDefault();
    });

    // INTERACTIVE MAP

    $(document).on('click', '.js-country-link', function(){
        var id = $(this).data('id');

        if(id != '') {
            $('.js-country-link').removeClass('c-countries__list-item--active');
            $(this).addClass('c-countries__list-item--active');
            $('.js-country-map-item').removeClass('active');
            $('#' + id).addClass('active');
            $('.js-country-item').removeClass('c-countries__city-list-item--active');
            $('.js-country-item.' + id).addClass('c-countries__city-list-item--active');
        }
    });

    $(document).on('click', '.js-country-map-item', function(){
        var id = $(this).attr('id');

        if(id != '') {
            $('.js-country-map-item').removeClass('active');
            $(this).addClass('active');
            $('.js-country-link').removeClass('c-countries__list-item--active');
            $('.js-country-link.' + id).addClass('c-countries__list-item--active');
            $('.js-country-item').removeClass('c-countries__city-list-item--active');
            $('.js-country-item.' + id).addClass('c-countries__city-list-item--active');
        }
    });

    // EVENTS

    $(document).on('click', '.js-event-link', function (e){
        e.preventDefault();
        $('body').addClass('u-no-scroll');
        var content = $(this).parent().html();
        $('.js-event-detail').addClass('c-events__detail--visible');
        $('.js-event-detail-inner').html(content);
    });

    $(document).on('click', '.js-event-close', function (e) {
        e.preventDefault();
        $('body').removeClass('u-no-scroll');
        $('.js-event-detail').removeClass('c-events__detail--visible');
        setTimeout(function (){
            $('.js-event-detail-inner').html('');
        }, 300);
    });

    function filterEvents(id) {
        $('.js-event-item').removeClass('c-events__item--visible');
        if(id == 'All') {
            $('.js-event-item').addClass('c-events__item--visible');
        } else {
            $('.js-event-item').each(function(){
                if($(this).data('country') == id) {
                    $(this).addClass('c-events__item--visible');
                }
            });
        }

        if($('.js-event-item.c-events__item--visible').length == 0) {
            $('.js-event-warning').fadeIn();
        } else {
            $('.js-event-warning').hide();
        }
    }

    if($('.js-event-item').length) {
        filterEvents('All');

        $('.js-event-date').each(function (){
            var from = $(this).find('.js-event-date-from');
            var to = $(this).find('.js-event-date-to');
            var dash = $(this).find('.js-event-date-dash');

            if (from.html() == to.html()) {
                to.hide();
                dash.hide();
            }

            else if(from.html().slice(to.length - 5) == to.html().slice(to.length - 5)) {
                from.html(from.html().slice(0, -5))
            }

        });
    }

    $(document).on('click', '.js-event-country', function(e){
        e.preventDefault();
        var id = $(this).data('country');
        $('.js-event-country').removeClass('active');
        $(this).addClass('active');
        filterEvents(id);
    });

    // REBRANDING STRIP

    $('.c-rebranding-strip__close-button').on('click', function () {
        $('.c-rebranding-strip').slideUp(400);
    });

    // BLOG

    $(document).on('click', '.js-use-link', function (){
        var link = $(this).data('url');
        window.location.href = link;
    });

    if($('.js-podcast-shortlist .js-use-link').length == 0) {
        $('.js-podcast-shortlist').hide();
    }

    // GROCERY ANIMATIONS

    $(document).on('click', '.js-start-car-animation', function (){
        $('.js-car-animation').addClass('c-grocery-intro__animation-car--play');
        setTimeout(function(){
            $('.js-bubble-animation').addClass('c-grocery-intro__animation-container--play');
            $('.js-grocery-intro').addClass('c-grocery-intro--animation-over');
        },1000)
    });

    $(window).on('scroll', function () {
        $('.js-car-animation').addClass('c-grocery-intro__animation-car--play');
        setTimeout(function(){
            $('.js-bubble-animation').addClass('c-grocery-intro__animation-container--play');
            $('.js-grocery-intro').addClass('c-grocery-intro--animation-over');
        },1000)
    });

    // GROCERY REFERENCE CAROUSEL

    if($('.js-reference-carousel').length) {
        $('.js-reference-logo').each(function(i){
            $(this).addClass('js-reference-logo-' + i)
            $(this).click(function(){
                $('.js-reference-logo').removeClass('c-grocery-reference__carousel-item--active');
                $(this).addClass('c-grocery-reference__carousel-item--active');
                $('.js-reference-item').removeClass('c-grocery-reference__carousel-content-item--active');
                $('.js-reference-item-' + i).addClass('c-grocery-reference__carousel-content-item--active');

                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: $(".js-reference").offset().top - 50
                    }, 500);
                }, 250)

            })
        });

        $('.js-reference-logo:first-of-type').addClass('c-grocery-reference__carousel-item--active');

        $('.js-reference-item').each(function(i){
            $(this).addClass('js-reference-item-' + i)
        });

        $('.js-reference-item-0').addClass('c-grocery-reference__carousel-content-item--active');

        $('.js-reference-carousel').slick({
            autoplay: true,
            speed: 200,
            autoplaySpeed: 2000,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            swipe: true,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    // LIGHTGALLERY

    if ($(".js-light-gallery").length > 0) {
        $(".js-light-gallery").lightGallery();
    }

    // STICKY ELEMENTS

    $('.js-sticky-placeholder').each(function(){
        $(this).css('height', $(this).find('.js-set-sticky').outerHeight());
    });

    var lastScrollTop = 0;

    $(window).on('scroll', function () {
        var st = $(this).scrollTop();

        $('.js-sticky-placeholder').each(function(){
            $(this).css('height', $(this).find('.js-set-sticky').outerHeight());
        });

        $('.js-set-sticky').each(function(){
            if (st > lastScrollTop && $(window).scrollTop() >= $(this).offset().top + $(this).outerHeight() - window.innerHeight) {
                // downscroll code
                $(this).addClass('js-sticky');
            }
            else if(st < lastScrollTop && $(window).scrollTop() <= $(this).parent('.js-sticky-placeholder').offset()?.top + $(this).outerHeight() - window.innerHeight){
                $(this).removeClass('js-sticky');
            }

            if($(this).outerHeight() < window.innerHeight) {
                $(this).parent().addClass('js-sticky-top');
            }
            else {
                $(this).parent().removeClass('js-sticky-top');
            }
        });
        lastScrollTop = st;
    });

    // USPs

    $(document).on('click', '.js-usp-title', function (){
        $(this).toggleClass('c-grocery-solution__usp-title--active');
    });

    // REFERENCE NUMBER

    if ($('.js-reference-number').length && $('.js-reference-form').length) {
        var value = $('.js-reference-number').data('reference');
        $('.js-reference-form').val(value);
    }

    // CONTENT HUB FILTER FOR CATEGORIES
    urlPath = window.location.pathname;

    if (urlPath.includes('category/')) {

        $('.c-blog-list__main .js-hide-non-categories').hide();
        $('.c-blog-list__side .js-hide-non-categories').hide();

        $('.c-blog-list__main .js-hide-non-categories').each( function( index, element ){
            const category = $( this ).data('category');
            if( urlPath.includes(category) ){
                $( this ).show();
            }
        });

        const showThree = [];
        $('.c-blog-list__side .js-hide-non-categories').each( function( index, element ){
            const category = $( this ).data('category');
            if( urlPath.includes(category)){
                showThree.push($( this ));
            }
        });

        if (showThree[0]) {
            showThree[0].css("display", "flex");
        }

        if (showThree[1]) {
            showThree[1].css("display", "flex");
        }
        if (showThree[2]) {
            showThree[2].css("display", "flex");
        }

    }

    // if($('.js-form-industry-option-replaced').length) {
    //     const formOptionsArr = Array.from(document.querySelectorAll('.js-form-industry-option-replaced'));
    //     const selectedOption = formOptionsArr.find(option => option.value.toLowerCase() === 'other')
    //     selectedOption.setAttribute('selected', true)
    // }
});

document.addEventListener( 'wpcf7sent', function( event ) {
    if ( '465' === event.detail.contactFormId ) {
        // 465 -> ID formuláru vo wp na produkcii
        window.location.href = 'https://idodo.cz/dodo-partner/dekujeme/';
    }
}, false );

// Number of offers
const numOfOffers = document.querySelectorAll('.c-work-at-dodo-vacancies__offer').length;
const textElement = document.querySelector('.o-text--pink');
if (textElement && numOfOffers) {
    textElement.innerHTML = numOfOffers;
}

// Redirect old content-hub links on social media
const pageUrl = window.location.href;
if (
    (pageUrl.includes('/gaia-data-driven-platforma-pro-efektivni-last-mile-logistiku')
        || pageUrl.includes('/case-study-pribeh-dodo-fransizanta')
        || pageUrl.includes('/podcast-dodo-cesta-ocima-martina-marka')
        || pageUrl.includes('/dodo-je-fransizorem-roku-2021')
        || pageUrl.includes('/case-study-unikatni-fransizovy-koncept-dodo-partner')
        || pageUrl.includes('/case-study-solutions-for-bageterie-boulevard')
        || pageUrl.includes('/uspora-10-000-hodin-pro-kosik')
        || pageUrl.includes('/last-mile-delivery-trendy-2022')
        || pageUrl.includes('/case-study-reseni-pro-bageterii-boulevard')
        || pageUrl.includes('/forbes-byznys-podcast-michal-mensik-dodo')
        || pageUrl.includes('/poznejte-hlavni-prekazky-optimalizace-posledni-mile')
        || pageUrl.includes('/jak-vypada-vyvoj-logisticke-platformy-u-nas-v-dodo')
        || pageUrl.includes('/kolik-casu-nam-dokazi-usetrit-moderni-informacni-technologie')
        || pageUrl.includes('/na-den-kuryrem-dodo-behem-nouzoveho-stavu-michal-mensik-ceo-dodo')
        || pageUrl.includes('/last-mile-delivery-pod-lupou')
    )
    && !pageUrl.includes('/content-hub/')) {
    window.location.pathname = '/content-hub' + window.location.pathname;
}

// Reference page show more button
const quantityToShow = 4;
const moreBlogsButton = document.querySelector('.js-load-more-blogs');
const allBlogs = Array.from(document.querySelectorAll('.js-blog-item'));
allBlogs.splice(0,4);
allBlogs.map( item => item.classList.add('hidden') );

const showMoreBlogs = function (showQuantity) {
    let hiddenBlogs = Array.from(document.querySelectorAll('.js-blog-item.hidden'));

    if (showQuantity <= hiddenBlogs.length ) {
        hiddenBlogs.slice(0, showQuantity).map((showItem)=>showItem.classList.remove('hidden'));

        if (showQuantity === hiddenBlogs.length) {
            moreBlogsButton.style.display = 'none';
        }
    } else {
        hiddenBlogs.slice(0, hiddenBlogs.length).map((showItem)=>showItem.classList.remove('hidden'));
        moreBlogsButton.style.display = 'none';
    }
}

if (moreBlogsButton){
    moreBlogsButton.addEventListener('click', (e) => {
        e.preventDefault();
        showMoreBlogs(quantityToShow);
    })
}
